import { CardAccountMailOutlineIcon } from './CardAccountMailOutlineIcon';

/**
 * author: Google
 * id F43579AB-0098-44B4-910C-3B24193C3B79
 * name card-account-mail-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/card-account-mail-outline.svg
 * tags
 * - Account / User 
 */
export const ContactMailOutlineIcon = CardAccountMailOutlineIcon;
export default ContactMailOutlineIcon